import axios from 'axios';
import qs from 'qs';
// axios.defaults.baseURL = '//db10.gamersky.com/StrategySetsEditor/'
// //j.gamersky.com/zq/db/cod16warzone/
axios.defaults.withCredentials=true;
const ajax = {
    // url: '//db10.gamersky.com/StrategySetsEditor/',
    post: function (url, data = {}, config = {}) {
        return new Promise((resolve, reject) => {
            axios.post(url, data, config)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },
    
    get: function (url, params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },
    put: function (url, data = {}) {
        return new Promise((resolve, reject) => {
            axios.put(url, qs.stringify(data))
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },
    del: function (url, data = {}) {
        return new Promise((resolve, reject) => {
            axios.delete(url, qs.stringify(data))
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },
    getQueryString: function (name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    },
    storage: {
        get: function (str) {
            return JSON.parse(localStorage.getItem(str))
        },
        set: function (str, data) {
            localStorage.setItem(str, JSON.stringify(data))
        }
    },

};

export default ajax;